<template>
  <el-upload
    ref="upload"
    action=""
    :auto-upload="false"
    :on-change="
      (file, fileList) => {
        onChangeFile(file, fileList);
      }
    "
    :before-remove="
      (file, fileList) => {
        beforeRemove(file, fileList);
      }
    "
    multiple
    :limit="20"
    :on-exceed="
      (file, fileList) => {
        handleExceed(file, fileList, 20);
      }
    "
    :file-list="fileList"
    accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="点击上传附件"
      placement="right"
    >
      <el-button size="small" type="primary">点击上传 </el-button>
    </el-tooltip>
    <div slot="tip" class="el-upload__tip">
      请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
    </div>
  </el-upload>
</template>

<script>

export default {
  props: {
    fileList: {
      type: Array,
      default: () => [],
      required: true,
    },
    url: {
      type: String,
      default: '',
      required: true,
    },
    uploadParams: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    // 上传附件
    onChangeFile (file, fileList) {
      let isLt5M = file.raw.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('文件内容必须小于5MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, this.url)
    },
    onUploadFile (file, fileList, uri) {
      let formData = new FormData()
      formData.append('file', file)
      Object.keys(this.uploadParams).forEach(key => {
        formData.append(key, this.uploadParams[key])
      })
      return request.alert(uri, formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)
        if (index > -1) {
          this.fileList[index] = {name: file.name, url: data, type: this.fileType(file)}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    beforeRemove (file, fileList) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    fileType (file) {
      let type = file.name.split('.').pop().toLowerCase()
      if (['jpeg', 'jpg', 'png'].includes(type)) {
        type = 'pic'
      } else if (['pdf'].includes(type)) {
        type = 'pdf'
      } else if (['eml', 'html', 'htm'].includes(type)) {
        type = 'eml'
      } else if (['xlsx', 'doc', 'docx'].includes(type)) {
        type = 'office'
      } else if (['zip'].includes(type)) {
        type = 'zip'
      }
      return type
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/payment-approval/components/PaymentAttachedFileUpload.vue